import React from "react";

import WsmFitmentAxisListPage from "../components/WsmFitmentAxisListPage";
import { useWsmFitmentAxes } from "../hooks/useWsmFitmentVocabulary";

export const WsmFitmentAxisListView = () => {
  const { axes, loading, error, retry } = useWsmFitmentAxes();

  return (
    <WsmFitmentAxisListPage axes={loading ? undefined : axes} onRetry={error ? retry : undefined} />
  );
};

export default WsmFitmentAxisListView;
